export default __webpack_public_path__ + "static/media/mt_mark-white.dbe98ff3.png";